// *********************************************************
// Copyright (c) 2017 Agra Technologies Pvt. Ltd.. All rights reserved
// *********************************************************
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalSettingsService } from 'src/app/_Common/_Services/global-settings.service';
import { UserService } from 'src/app/_Common/_Services/user.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(
    private globalSettings: GlobalSettingsService,
    private http: HttpClient,
    private userService: UserService
  ) {}

  getAllRecoveryData(): Observable<any> {
    return this.http
      .get(this.globalSettings.getApiUrl() + '/api/dashboard/allRecoverySummary')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getAllFollowUpSummary(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/viewData/agentFollowUpCount', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getFollowUpSummaryAndDefaulterDetails(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/viewData/agentFollowUpCountAndDefaulterDetails', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getTotalRecoveryData(): Observable<any> {
    return this.http
      .get(this.globalSettings.getApiUrl() + '/api/dashboard/totalRecovery')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getDueData(): Observable<any> {
    return this.http
      .get(this.globalSettings.getApiUrl() + '/api/dashboard/allDues')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getNewNumbers(): Observable<any> {
    return this.http
      .get(this.globalSettings.getApiUrl() + '/api/dashboard/getNewIncomingNumbers')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  searchDefaulter(postBody): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/searchDefaulter', postBody)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  mapDefaulter(postBody): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/mapDefaulter', postBody)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getRecoveryReport(instituteId, postBody): Observable<any> {
    let url = '/api/dashboard/recoveryReport';
    if (instituteId == 9) {
      url = '/api/mobile/getTaskCountGroupbyTitle';
    }
    return this.http
      .post(this.globalSettings.getApiUrl() + url, postBody)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getRecoveryReportClient(instituteId, postBody): Observable<any> {
    const url = '/api/dashboard/recoveryReportClient';
    return this.http
      .post(this.globalSettings.getApiUrl() + url, postBody)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getFlowData(instituteId, postBody): Observable<any> {
    const url = '/api/dashboard/getFlowData';
    return this.http
      .post(this.globalSettings.getApiUrl() + url, postBody)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  getBucketFlowData(instituteId, postBody): Observable<any> {
    const url = '/api/dashboard/getBucketFlowData';
    return this.http
      .post(this.globalSettings.getApiUrl() + url, postBody)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getAllCommunicationWithBucket(instituteId): Observable<any> {
    let urlString = '/api/dashboard/userAllCommunicationWithBucket';
    if (instituteId === 9) {
      urlString = '/api/dashboard/userAllCommunicationWithBucketForMahindra';
    }
    return this.http
      .get(this.globalSettings.getApiUrl() + urlString)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getEscalations(postObj) {
    // 23 is Phonelog Communication Config Id -- taken for sample test -- get replaced by escalation configId ---Ashok
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/getEscalation', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getInstructions(postObj) {
    // 23 is Phonelog Communication Config Id -- taken for sample test -- get replaced by escalation configId ---Ashok
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/getInstruction', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getAllOffers(postObj) {
    // 23 is Phonelog Communication Config Id -- taken for sample test -- get replaced by escalation configId ---Ashok
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/getAllOffer', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getAllCommunicationWithBucketForSpecificPeriod(postObj): Observable<any> {
    const urlString = this.globalSettings.checkAndGetV3Url(location.pathname, '/api/dashboard/userAllCommunicationWithBucketForSpecificPeriod');
    return this.http
      .post(this.globalSettings.getApiUrl() + urlString, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getRegionList(InstituteId) {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/getRegionList', {
        InstituteId: InstituteId,
        isLocality: true,
        isStateMaster: false
      })
      // .map(res => res)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  getBranchList(InstituteId) {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/getBranchList', {
        InstituteId: InstituteId
      })
      // .map(res => res)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getDispositionCodeList(InstituteId) {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/getDispositionCodeList', { InstituteId: InstituteId })
      // .map(res => res)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getBucketList(InstituteId) {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/getBucketList', {
        InstituteId: InstituteId
      })
      // .map(res => res)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  getCommunicationConfigs(): Observable<any> {
    return this.http
      .get(this.globalSettings.getApiUrl() + '/api/communicationManager/showCommunicationConfigs')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getMapChanges(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/userduemapchanges/fetchChangesDueMaps', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getMapsonDate(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/userduemapchanges/fetchDueMapsDetails', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  getMapChangesApproval(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/userduemapchanges/fetchChangesDueMapsApproval', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getMapsonDateApproval(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/userduemapchanges/fetchDueMapsDetailsApproval', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getUserData(): Observable<any> {
    return this.http
      .get(this.globalSettings.getApiUrl() + '/api/viewData/users')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  onApproveDues(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/userduemapchanges/approveDueMaps', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  getIntensity(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/getIntensity', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  getDashboardComponents(): Observable<any> {
    return this.http
      .get(this.globalSettings.getApiUrl() + '/api/dashboard/getDashboardComponents')
      .pipe(catchError((e: any) => this.userService.getCheckError(e, true)));
  }

  getAccountsOverview(postObj: any): Observable<any> {
    let payload = btoa(JSON.stringify(postObj));
    return this.http
      .get(this.globalSettings.getApiUrl() + '/api/dashboard/getAccountService?q=' + payload)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  getMisReports(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/getMISResolution', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getCommunicationDetails(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/getCommunicationDetails', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getPTPSummary(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/ptpSummary', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  getFieldReportSummary(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/fieldVisitReport', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  updateAddressGeoloction(postObj, id): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/timeline3/updateDefaulterAddress/' + id, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  deleteDefaulterAddress(defaulterAddress): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/timeline3/deleteDefaulterAddress', defaulterAddress)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // for dashboard getPortfolioPerformance
  getPortfolioPerformance(postData): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/dashboard/visualisationReport', postData)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  verifyBulkOffer(postObj): Observable<any> {
    return this.http
      .post(this.globalSettings.getApiUrl() + '/api/timeline3/verifyBulkOffer', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getAllDRPRequests(postObj: any): Observable<any> {
    return this.http
      .post(`${this.globalSettings.getApiUrl()}/api/dashboard/getAllDRPDetails`, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  modifyDRPDetail(postObj: any): Observable<any> {
    return this.http
      .post(`${this.globalSettings.getApiUrl()}/api/timeline4/modifyDRPDetail`, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getUserLastLoginDetail(postObj: any): Observable<any> {
    return this.http
      .post(`${this.globalSettings.getApiUrl()}/api/dashboard/getActiveUserLastLoginDetail`, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  getNotifications(): Observable<any> {
    return this.http
      .get(this.globalSettings.getApiUrl() + '/api/dashboard/getNotification')
      .pipe(catchError((e: any) => this.userService.getCheckError(e, true)));
  }

  getUserReportees(): Observable<any> {
    return this.http
      .get(`${this.globalSettings.getApiUrl()}/api/dashboard/getUsersList`)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  getCampaignsList(): Observable<any> {
    return this.http
      .get(`${this.globalSettings.getApiUrl()}/api/dashboard/getAllCampaigns`)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  agentPerformanceReport(postObj): Observable<any>{
    return this.http
      .post(`${this.globalSettings.getApiUrl()}/api/dashboard/dialerLoginPerformanceReport`, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  callDetailsViewReport(postObj): Observable<any>{
    return this.http
      .post(`${this.globalSettings.getApiUrl()}/api/dashboard/getCallDetailsViewReport`, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  dispostionReport(postObj): Observable<any>{
    return this.http
      .post(`${this.globalSettings.getApiUrl()}/api/dashboard/getDispositionsReports`, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getCampaignReport(postObj): Observable<any> {
    return this.http
      .post(`${this.globalSettings.getApiUrl()}/api/dashboard/getCampainReports`, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getCampaugnDripDownReport(postObj): Observable<any> {
    return this.http
      .post(`${this.globalSettings.getApiUrl()}/api/dashboard/getAgentReportByCampainId`, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getBusinessReport(postObj): Observable<any> {
    return this.http
      .post(`${this.globalSettings.getApiUrl()}/api/dashboard/getBusinessReport`, postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
}
